import React from "react";
export const TextContainer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-container ".concat(className || "")
  }, children);
});